const configuratorLetters = {

    settings: {
      ribbon: null,
      letter: null
    },

    init: () => {

        configuratorLetters.modalCloseApp();
        configuratorLetters.tabs();
        configuratorLetters.productEvents();
        configuratorLetters.galleryEvents();
        configuratorLetters.initSwipers();
        configuratorLetters.handleAddToCartButton();
        configuratorLetters.mobileCart();
        configuratorLetters.previewButtons();

    },

    tabs: () => {

        let tabs            = document.querySelectorAll('.tab-link');

        if ( tabs ) {
            
            [].forEach.call( tabs, (tab) => {

                tab.addEventListener( 'click', (e) => {
                    e.preventDefault();

                    if ( tab.classList.contains('active') ) {
                      return;
                    }

                    const selector      = tab.getAttribute('data-target')
                    const tabContent    = document.querySelectorAll(selector);
                    const activeTabs    = document.querySelectorAll('.tab-content.active');

                    document.querySelector('.tab-link.active').classList.remove('active');                    
                    tab.classList.add('active');

                    [].forEach.call(tabContent, (e)=> {
                      e.classList.add('active');
                    });

                    [].forEach.call(activeTabs, (e) => {
                      e.classList.remove('active');
                    });

                });

            });

        }

    },

    previewButtons: () => {

      let buttons   = document.querySelectorAll('.configurator__letters__preview__buttons .button');

      if ( buttons ) {

        [].forEach.call(buttons, (btn) => {

          btn.addEventListener('click', () => {

            let makeActive  = btn.getAttribute('make-active');
            let tab         = document.querySelector(`.configurator__letters__header__tabs [data-target="[${makeActive}]"]`);

            tab.click();

            document.querySelector('.configurator__letters__preview__buttons .button.hidden').classList.remove('hidden');
            btn.classList.add('hidden');

          });

        });

      }

    },

    modalCloseApp: () => {

      let close       = document.querySelector('.js-close-app');
      let modal       = document.querySelector('.close-confirm');
      let modalClose  = document.querySelectorAll('.close-modal');

      close.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', false);
      });

      modalClose.forEach((close)=>{
        close.addEventListener('click', () => {
          modal.setAttribute('aria-hidden', true);
        });
      });

    },

    mobileCart: () => {

      let trigger   = document.querySelector('.configurator__letters__total svg');
      let cart      = document.querySelector('.configurator__letters__cart');
      let close     = document.querySelector('.configurator__letters__cart .close');

      if ( trigger ) {
        trigger.addEventListener('click', () => {
          cart.classList.toggle('active');
        });
      }

      if ( close ) {
        close.addEventListener('click', () => {
          cart.classList.remove('active');
        });
      }

    },

    productEvents: () => {

        let products    = document.querySelectorAll('.products__list__item');

        if ( products ) {

            [].forEach.call(products, (product) => {

                let choose  = product.querySelector('[data-action="select-product"]');

                if ( window.innerWidth > 1023 ) {
                    configuratorLetters.createTooltip(product);
                } else {
                  product.addEventListener('click', () => {
                    configuratorLetters.selectProduct(product.dataset.product, product.dataset.type);
                  })
                }

                choose.addEventListener('click', () => {
                  configuratorLetters.selectProduct(choose.dataset.product, choose.dataset.type);
                })

            });

            // Set default product
            configuratorLetters.selectProduct(products[0].dataset.product, products[0].dataset.type);

        }

    },

    selectProduct: (product, type) => {

      document.dispatchEvent(new CustomEvent("theme:loading:start"));

      let id      = Number(product);
      let items   = document.querySelectorAll(`.products__list__item[data-type="${type}"]`);

      [].forEach.call(items, (item) => {
        
        item.classList.remove('selected');
        if ( Number( item.dataset.product ) === id ) {
          item.classList.add('selected');

          if ( type == 'product' || type == 'paid' ) {
            configuratorLetters.settings.ribbon = item;
          } else {
            configuratorLetters.settings.letter = item;
          }
          
        }
        
      });

      if ( type == 'product' || type == 'paid' ) {
        let previewHolder   = document.querySelector('#ribbon-preview');
        let cartItemHolder  = document.querySelector('#ribbon-cartitem');
        previewHolder.setAttribute('src', configuratorLetters.settings.ribbon.dataset.preview);
        configuratorLetters.addToCart(cartItemHolder, configuratorLetters.settings.ribbon);
      }

      if ( type == 'letter' ) {
        let previewHolder   = document.querySelector('#letter-preview');
        let cartItemHolder  = document.querySelector('#letter-cartitem');
        previewHolder.setAttribute('src', configuratorLetters.settings.letter.dataset.preview);
        configuratorLetters.addToCart(cartItemHolder, configuratorLetters.settings.letter);
      }

      // Check if we can go to cart with products
      configuratorLetters.addToCartButtonState();

      document.dispatchEvent(new CustomEvent("theme:loading:end"));

    },

    addToCart: ( holder, item ) => {

      let image     = item.dataset.cartimage;
      let title     = item.dataset.title;
      let price     = item.dataset.price;

      holder.innerHTML = `<div class="cart-item">
        <figure><img src="${image}" alt="${title}"></figure>
        <div class="cart-item__details">
          <h5>${title}</h5>
        </div>
        <div class="cart-item__price">${price}</div>
      </div>`;

    },

    addToCartButtonState: () => {

      let submitButton  = document.querySelector('.configurator__letters__total .add-to-cart');
      submitButton.setAttribute('disabled', 'disabled');

      if ( configuratorLetters.settings.letter !== null && configuratorLetters.settings.ribbon !== null ) {

        let form          = document.querySelector('.configurator__letters__form');
        let product       = form.querySelector('.product-id');
        let properties    = form.querySelector('.product-property');

        product.value     = configuratorLetters.settings.letter.dataset.variant;
        properties.value  = configuratorLetters.settings.ribbon.dataset.title;

        submitButton.removeAttribute('disabled');
      }

    },

    hashCode: () => {
      var hash = 0,
      i, chr;
      if (this.length === 0) return hash;
      for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
      }
      return hash;
    },

    handleAddToCartButton: () => {

      let submitButton  = document.querySelector('.configurator__letters__total .add-to-cart');
      let form          = document.querySelector('.configurator__letters__form');

      submitButton.addEventListener('click', () => {
        if ( submitButton.getAttribute('disabled') ) {
          return;
        }

        // Proceed with add to cart
        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        if ( configuratorLetters.settings.ribbon.dataset.price.length > 0 ) {

          // Add to cart main product - letter
          // Add to cart second product - paid ribbon
          var cartItems = {
            items: [{
                id: form.querySelector('.product-id').value,
                quantity: 1,
                properties: {
                  _hash: configuratorLetters.settings.ribbon.dataset.product
                }
              },
              {
                id: document.querySelector(`.products__list__item--paid[data-product="${configuratorLetters.settings.ribbon.dataset.product}"]`).getAttribute('data-variant'),
                quantity: 1,
                properties: {
                  _hash: form.querySelector('.product-id').value 
                }
              }
            ]
          }
        } else {
          var cartItems = {
            items: [{
                id: form.querySelector('.product-id').value,
                quantity: 1,
                properties: {
                  _ribbon: form.querySelector('.product-property').value
                }
              }
            ]
          }
        }

        console.log(cartItems);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: JSON.stringify(cartItems),
          headers: {
            'Content-Type': 'application/json'
          },
        })
        .then((response) => response.json())
        .then((response) => {
          if ( response.items.length > 0 ) {
            window.location.replace(routes.cartUrl);
          } else {
            alert(response.message);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        });
      });

    },

    galleryEvents: () => {
      var opens = document.querySelectorAll("[data-action='open-gallery']");
      var closes = document.querySelectorAll(".Gallery__Close");
      var gallery = document.querySelector('.Gallery');
      var chooseButton = gallery.querySelector('.Gallery__ProductButton');

      opens.forEach((element) => {
        element.addEventListener('click', function(event) {
          configuratorLetters.openGallery(event)
        })
      }); 

      closes.forEach((element) => {
        element.addEventListener('click', function(event) {
          configuratorLetters.closeGallery(event)
        })
      });

      gallery.addEventListener('click', function(event){
        if (event.target.classList.contains('Gallery')) {
          configuratorLetters.closeGallery(event)
        }
      });

      chooseButton.addEventListener('click', () => {
        configuratorLetters.selectProduct(chooseButton.dataset.product, chooseButton.dataset.type);
      });

    },

    createTooltip(element) {

        const tooltipElement = element.querySelector(".Tooltip--main");
    
        if (!tooltipElement) return;
    
        const popperInstance = Popper.createPopper(
          element,
          tooltipElement,
          {
            placement: "right",
            offset: [0, 8],
          }
        );
    
        function show() {
          if (element.classList.contains("disabled")) return;
    
          tooltipElement.setAttribute("data-show", "");
          popperInstance.update();
        }
    
        function hide() {
          tooltipElement.removeAttribute("data-show");
        }
    
        const showEvents = ["mouseenter", "focus"];
        const hideEvents = ["mouseleave", "blur"];
    
        showEvents.forEach((event) => {
          element.addEventListener(event, show);
        });
    
        hideEvents.forEach((event) => {
          element.addEventListener(event, hide);
        });
    
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
              if (element.classList.contains("disabled")) {
                hide();
              }
            }
          });
        });
    
        observer.observe(element, {
          attributes: true,
        });

    },

    initSwipers: () => {

      let swiperWrappers    = document.querySelector('.configurator__letters__products--mobile');
      let swipers           = swiperWrappers.querySelectorAll('.products__list .swiper');

      if ( swiperWrappers && swipers ) {
        [].forEach.call(swipers, (swiperInstance) => {
          const swiper = new Swiper(swiperInstance, {
            slidesPerView: 3,
            spaceBetween: 20,
            scrollbar: {
              el: '.swiper-scrollbar',
            },
          });
        })
      }

    },

    openGallery(event) {
      const el = {
        gallery: document.querySelector('.configurator__letters .Gallery'),
        inner: document.querySelector('.configurator__letters .Gallery__Slideshow'),
        title: document.querySelector('.configurator__letters .Gallery__ProductTitle'),
        button: document.querySelector('.configurator__letters .Gallery__ProductButton')
      };
      const productId   = Number(event.target.dataset.product);
      const productType = event.target.dataset.type;
      const product     = window.letters.all[productId];
      let galleryHtml   = '';
  
      if (product) {
        for (let i = 0; i < product.images.length; i++) {
          const image = 'https:' + product.images[i];
          galleryHtml += `<div class="Gallery__SlideshowItem"><img src="${image}" alt="${product.title}"></div>`;
        }
        el.inner.innerHTML = galleryHtml;
  
        window.letters.gallery = new Flickity(el.inner, {
          contain: true,
          adaptiveHeight: true,
          pageDots: false
        });
        
        el.title && (el.title.innerHTML = product.title);
        el.button && (el.button.dataset.product = productId);
        el.button && (el.button.dataset.type = productType);
        el.gallery.classList.add('visible');

      }
    },

    closeGallery(event = null) {
      event && event.preventDefault();
  
      const gallery = document.querySelector('.configurator__letters .Gallery');
      gallery && gallery.classList.remove('visible');
    }

}

configuratorLetters.init();